import { ICustomerRequest, ICustomerResponse } from "../contracts/Customer";
import { postDataAsync } from "../ZeosApiExecutor";
import { ICustomer } from "./interfaces/ICustomer";

let accountPrefix = "/Customer/";

export const Customer: ICustomer = {
  postCustomerAsync: async (customer: ICustomerRequest) => {
    const response = await postDataAsync<ICustomerResponse>(
      `${accountPrefix}Create`,
      customer
    );
    return response;
  },
};
